import classnames from 'classnames';
import React from 'react';
import './MonkeyBadge.pcss';

export enum BadgeTheme {
  yellowGradient = 'theme-yellow-gradient',
  yellow = 'theme-yellow',
  purpleGradient = 'theme-purple-gradient',
  blueGradient = 'theme-blue-gradient',
  errorRed = 'theme-error-red',
  green = 'theme-green',
  greenGradient = 'theme-green-gradient',
  gray = 'theme-gray',
  pinkGradient = 'theme-pink-gradient',
  lightBlueToGreenGradient = 'theme-light-blue-to-green-gradient',
  unicornGradient = 'theme-unicorn-gradient',
  starterGradient = 'theme-starter-gradient',
  morePurpleUnicornGradient = 'theme-more-purple-unicorn-gradient',
  lightPinkGradient = 'theme-light-pink-gradient',
  lightPurple = 'theme-light-purple',
  lightOrange = 'theme-light-orange',
}

type Props = {
  children?: React.ReactNode;
  className?: string;
  theme?: BadgeTheme;
  size?: number;
  style?: React.CSSProperties;
  unwrappedChildren?: boolean;
};

const MonkeyBadge = (props: Props) => {
  const {
    children,
    className,
    theme,
    size,
    style: styleFromProps,
    unwrappedChildren,
  } = props;
  const selectedTheme = theme || BadgeTheme.yellowGradient;
  const classList = classnames(
    'monkey-badge',
    className,
    `monkey-badge--${selectedTheme}`,
  );
  const fontSize = size || 14;
  const style = {
    fontSize: `${fontSize}px`,
    ...styleFromProps,
  };

  return (
    <div className={classList} style={style}>
      {children && unwrappedChildren ? (
        <>{children}</>
      ) : (
        <div className="monkey-badge__text-wrapper">{children}</div>
      )}
    </div>
  );
};

export { MonkeyBadge };
